import React, { useEffect } from "react";
import _43_login from "./_43_login.js";
const MODULE_NAME = "today_pg_login MH";

const userId = 1;
const activeDate = new Date().toISOString().slice(0, 10);
const screen = "today_pg_login MH";

/**
 * Login Page Component
 * Handles both regular login and demo login redirect
 */
const LoginPage = (props) => {
    const handleLoginSuccess = (...args) => {
        const url = new URL(window.location.href);
        url.searchParams.delete("date");
        window.history.replaceState({}, "", url.pathname + url.search);
        if (props.onLoginSuccess) {
            props.onLoginSuccess(...args);
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const isDemoLogin = params.has("demo");
        const screenParam = params.get("screen"); // Extract screen parameter

        if (isDemoLogin) {
            // Check if demo session is active
            fetch(`${process.env.REACT_APP_API_URL}/api/check-session`, {
                credentials: "include"
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.logged_in) {
                        if (data.account_type) {
                            sessionStorage.setItem("account_type", data.account_type);
                        }
                        // Pass screen parameter to parent component
                        if (props.onLoginSuccess) {
                            props.onLoginSuccess(data.account_type, screenParam);
                        }
                    }
                })
                .catch((err) => {
                    console.error("[LoginPage] Demo session check failed:", err);
                });
        }
    }, [props]);

    return (
        <div className="_login-page" data-analytics={MODULE_NAME}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "24px" }}>
                <a href="https://www.tontradingtools.com" rel="noopener noreferrer">
                    <img
                        src="images/logo/logo.png"
                        alt="Logo"
                        style={{
                            height: "40px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            marginRight: "16px"
                        }}
                    />
                </a>
            </div>
            <_43_login
                {...props}
                userId={userId}
                activeDate={activeDate}
                screen={screen}
                onLoginSuccess={handleLoginSuccess}
            />
        </div>
    );
};

export default LoginPage;